import View from "./view";
import React from "react";

export default function ContactUs() {
  return <View />;
}



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.jsx